import {
  Add_Rotation_Type,
  Delete_One_Rotation_Type,
  Get_All_Rotation_Type,
  Get_Error,
  Get_One_Rotation_Type,
  Update_One_Rotation_Type,
} from '../Types';

const intial = {
  Rotation: [],
  UpdateRotation: [],
  loading: true,
};

const Rotation_Reducer = (state = intial, action) => {
  switch (action.type) {
    case Get_All_Rotation_Type:
      return {
        ...state,
        Rotation: action.payload,
        loading: false,
      };
    case Add_Rotation_Type:
      return {
        Rotation: action.payload,
        loading: false,
      };
    case Delete_One_Rotation_Type:
      return {
        Rotation: action.payload,
        loading: false,
      };
    case Get_One_Rotation_Type:
      return {
        Rotation: action.payload,
        loading: false,
      };
    case Update_One_Rotation_Type:
      return {
        ...state,
        UpdateRotation: action.payload,
        loading: false,
      };
    case Get_Error:
      return {
        loading: true,
        RolesData: action.payload,
      };

    default:
      return state;
  }
};
export default Rotation_Reducer;
